var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5195 0.98877H1.47656C0.660156 0.98877 0 1.6333 0 2.43018V19.5435C0 20.3403 0.660156 20.9888 1.47656 20.9888H18.5195C19.3359 20.9888 20 20.3403 20 19.5474V2.43018C20 1.6333 19.3359 0.98877 18.5195 0.98877ZM5.93359 18.0317H2.96484V8.48486H5.93359V18.0317ZM4.44922 7.18408C3.49609 7.18408 2.72656 6.41455 2.72656 5.46533C2.72656 4.51611 3.49609 3.74658 4.44922 3.74658C5.39844 3.74658 6.16797 4.51611 6.16797 5.46533C6.16797 6.41064 5.39844 7.18408 4.44922 7.18408ZM17.043 18.0317H14.0781V13.3911C14.0781 12.2856 14.0586 10.8599 12.5352 10.8599C10.9922 10.8599 10.7578 12.0669 10.7578 13.313V18.0317H7.79688V8.48486H10.6406V9.78955H10.6797C11.0742 9.03955 12.043 8.24658 13.4844 8.24658C16.4883 8.24658 17.043 10.2231 17.043 12.7935V18.0317V18.0317Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9b3a56656e74607b1ec59d827c95cdbc.svg";
export { ForwardRef as ReactComponent };